/**
 * Thornhaven shared building style
 * --------------------------------
 * One palette + a readable serif font so every live/interactable building in
 * Thornhaven shares the same Gothic / Victorian / Norse-fantasy texture
 * language (ashlar stone ground floors, dark timber trim, warm stained walls,
 * steep slate roofs, gold signage). Import this everywhere instead of
 * re-declaring per-building colours so nothing clashes.
 */

export const TH_STYLE = {
  // Stone (ashlar) — cool grey-blue, reads as a carved civic base
  stone: '#767e89',
  stoneDark: '#464c56',
  stoneLight: '#949ba6',
  // Timber — warm stained walls with near-black trim beams
  timber: '#6a4428',
  timberDark: '#4a2e18',
  timberTrim: '#201309',
  // Plaster infill panels (Victorian half-timber feel)
  plaster: '#cdbfa3',
  // Roofing — dark slate
  roof: '#2a2f39',
  roofDark: '#1c2027',
  roofRidge: '#15181e',
  // Accents
  gold: '#cda534',
  goldDark: '#8f6f1c',
  copper: '#4f6b5a',
  // Lights
  window: '#ffcf7a',
  flame: '#ff7a1a',
  door: '#2c1d10',
};

// Local serif font (downloaded, CC/OFL) for all 3D signage — reliable offline.
export const SIGN_FONT = '/fonts/Cinzel-SemiBold.ttf';
